import { numeric, sum } from './dashboardMetrics.js';

export function monthRange(from, to) {
  const result = [];
  let year = Number(from.slice(0, 4));
  let month = Number(from.slice(5, 7));
  const end = to.slice(0, 7);
  while (`${year}-${String(month).padStart(2, '0')}` <= end && result.length < 1200) {
    result.push(`${year}-${String(month).padStart(2, '0')}`);
    if (++month > 12) { month = 1; year += 1; }
  }
  return result;
}

export function alfawinMetrics(data, filters, today) {
  const invoices = data.invoices || [];
  const debts = data.debts || [];
  const sales = invoices.filter((r) => r.kind === 'sales');
  const purchases = invoices.filter((r) => r.kind === 'purchases');
  const receivables = debts.filter((r) => r.kind === 'sales');
  const payables = debts.filter((r) => r.kind === 'purchases');
  const months = monthRange(filters.from, filters.to).map((month) => {
    const rows = invoices.filter((r) => r.date?.startsWith(month));
    const accounting = (data.pnl || []).find((r) => r.month === month);
    const genaen = filters.company === 'all' ? rows.filter(r => r.company === 'a') : [];
    const extraIncome = sum(genaen.filter(r => r.kind === 'sales'), 'net');
    const extraExpense = sum(genaen.filter(r => r.kind === 'purchases'), 'net');
    return { month, sales: sum(rows.filter((r) => r.kind === 'sales'), 'net'), purchases: sum(rows.filter((r) => r.kind === 'purchases'), 'net'),
      income: numeric(accounting?.income) + extraIncome, expense: numeric(accounting?.expense) + extraExpense, result: numeric(accounting?.result) + extraIncome - extraExpense };
  });
  const debtSummary = (rows) => ({
    balance: sum(rows, 'balance'),
    overdue: sum(rows.filter((r) => r.due_date && r.due_date < today), 'balance'),
    upcoming: sum(rows.filter((r) => r.due_date && r.due_date >= today), 'balance'),
    undated: sum(rows.filter((r) => !r.due_date), 'balance'),
  });
  return { sales, purchases, receivables, payables, months,
    salesNet: sum(sales, 'net'), purchasesNet: sum(purchases, 'net'),
    receivable: debtSummary(receivables), payable: debtSummary(payables) };
}

export function evolutionPeriod(month, frequency = 'quarter') {
  return frequency === 'month' ? month.slice(0, 7) : `${month.slice(0, 4)} · T${Math.ceil(Number(month.slice(5, 7)) / 3)}`;
}

export function groupEvolution(months, frequency) {
  const groups = new Map();
  for (const row of months) {
    const period = evolutionPeriod(row.month, frequency);
    const group = groups.get(period) || { month: period, sales: 0, purchases: 0, income: 0, expense: 0, result: 0 };
    for (const key of ['sales', 'purchases', 'income', 'expense', 'result']) group[key] += numeric(row[key]);
    groups.set(period, group);
  }
  return [...groups.values()];
}

export function groupAccounts(rows, digits = '2', names = {}) {
  const groups = new Map();
  for (const row of rows) {
    const account = String(row.account || '').trim();
    const code = digits === 'full' ? account : account.slice(0, Number(digits));
    const group = groups.get(code) || { account: code, income: 0, expense: 0, result: 0, descriptions: new Set() };
    group.income += numeric(row.income);
    group.expense += numeric(row.expense);
    group.result += numeric(row.income) - numeric(row.expense);
    if (row.description) group.descriptions.add(row.description);
    groups.set(code, group);
  }
  return [...groups.values()].sort((a, b) => a.account.localeCompare(b.account)).map(({ descriptions, ...group }) => ({
    ...group, description: String(names?.[group.account] || '').trim() || (digits === 'full' ? [...descriptions].join(' · ') : `Cuentas con prefijo ${group.account}`),
  }));
}
